import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';

registerLocaleData(localeEs, 'es-ES');

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
